export const prioritiesEnum = Object.freeze({
  COLOR: 0,
  PAINT_FINISH: 1,
  WHEEL_SIZE: 2,
  FRAME_FABRIC: 3,
  REAR_SHOCK_ABSORBER: 4,
  GEARS_NUMBER: 5,
  ELECTRIC_BIKE: 6,
  OPTIONAL_DESTINY: 7,
  OPTIONAL_AREA: 8,
});
